import React, { useState, Fragment } from "react"
import { Helmet } from "react-helmet"
import gql from "graphql-tag"
import styled from "@emotion/styled"
import { useMutation } from "@apollo/client"
import { MaxWidth } from "../UI/Containers"
import { FormFlex } from "./Contact"
import { Input, TextArea } from "../UI/Input";
import { SubmitButton } from "../UI/Button"
import { SentMessage } from "./InterestBusiness"

const InterestWrapper = styled("section")`
  padding: ${(props) => props.theme.spacing.default};
  text-align: center;
  .column {
    flex-direction: column;
    align-items: center;
  }
  input,
  textarea {
    margin: 1rem !important;
    position: relative;
    max-width: 400px;
    width: calc(100% - 2rem);
  }
`;


export const ParkingContent = (props) => {
  const page = props.page;
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{page.title}</title>
      </Helmet>


      <React.Fragment>
        <PageSection>
          <MaxWidth
            dangerouslySetInnerHTML={{
              __html: page.content,
            }}
          />
        </PageSection>
        <ParkingForm/>
        {page.boxSet &&
          page.boxSet.map((box, index) => {
            return (
              <PageSection key={index}>
                <MaxWidth>
                  <h1>{box.title}</h1>
                  {box.content && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: box.content,
                      }}
                    />
                  )}
                </MaxWidth>
              </PageSection>
            );
          })}
      </React.Fragment>
    </div>
  );
};




const ParkingForm = () => {
  const [form, setForm] = useState({});
  const [sent, setSent] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const [sendEmailMutation, { loading: mutationLoading, error: mutationError }] = useMutation(FORM_MUTATION, {
    onCompleted: (data) => {
      if (data?.sendEmail?.ok) {
        setSent(true);
        setSubmitError(false);
      } else {
        setSubmitError(true);
      }
    },
    onError: (error) => {
      console.error("Parking interest submission error:", error);
      setSubmitError(true);
    }
  });

  const prepareSendData = (currentForm) => ({
    name: currentForm.name,
    email: currentForm.email,
    message: `Adress: ${currentForm.address || ''} \nTelefon: ${currentForm.phone || ''} \nPersonnummer: ${currentForm.pid || ''} \nÖvrigt: ${currentForm.other || ''}`,
    sendTo: "lagenheter@orvelinfastigheter.se", // Assuming same recipient as apartments
    subject: `Intresseanmälan p-plats/garage från ${currentForm.name || 'Okänd'}`,
  });

  const updateData = (e) => {
    setForm(prevForm => ({
      ...prevForm,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitError(false);
    // Add basic validation if needed
    if (!form.name || !form.email || !form.phone || !form.pid) {
        setSubmitError(true);
        return;
    }
    const emailData = prepareSendData(form);
    sendEmailMutation({ variables: { emailData } });
  };

  return (
    <Fragment>
      <InterestWrapper>
        <h2>Intresseanmälan p-plats eller garage</h2>
        <MaxWidth>
          {sent ? (
            <SentMessage>
              <p>Din intresseanmälan är skickad!</p>
            </SentMessage>
          ) : (
            <form onSubmit={handleSubmit}>
              <FormFlex className="column" onChange={updateData}>
                <Input name="name" placeholder="Vad heter du?" required />
                <Input name="email" type="email" placeholder="Vad är din e-post?" required />
                <TextArea name="address" placeholder="Fullständig adress" />
                <Input name="phone" placeholder="Telefonnummer" required />
                <Input name="pid" placeholder="Personnummer" required />
                <TextArea name="other" placeholder="Övriga önskemål" />
                {/* Hidden input likely unnecessary */}
                {/* <Input name="type" required type="hidden" value="PARKING" /> */}
              </FormFlex>
              {(submitError || mutationError) && (
                  <p style={{ color: 'yellow' }}>
                    Något gick fel, har du fyllt i samtliga obligatoriska fält korrekt?
                  </p>
              )}
              <SubmitButton type="submit" disabled={mutationLoading}>
                {mutationLoading ? "Skickar..." : "Skicka intresseanmälan!"}
              </SubmitButton>
            </form>
          )}
        </MaxWidth>
      </InterestWrapper>
    </Fragment>
  );
};

const FORM_MUTATION = gql`
  mutation SendMail($emailData: EmailInput!) {
    sendEmail(emailData: $emailData) {
      ok
    }
  }
`;

export const PageSection = styled("section")`
    line-height: 1.5em;
    &:nth-child(even) {
        background: ${props => props.theme.colors.accent};
    }
    padding: ${props => props.theme.spacing.default};
    ${props => props.theme.bp.below.sm} {
        padding: ${props => props.theme.spacing.small};
    }
    > div {
        padding: 0px 150px;
        ${props => props.theme.bp.below.sm} {
            padding: 0px;
    }
    a{
        text-decoration:underline;
    }
    table{
        width:100%;
        border-collapse:collapse;
        th,td{
            margin:0;
            border:0;
            padding:.5rem;
            text-align:left;
        }
        tr:nth-of-type(even){
            background:white;
        }
        tr:nth-of-type(odd){
            background:#f1f1f1;
        }
        th{
            background: ${props => props.theme.colors.secondary};
            color:white;
        }
    }

    table.invoice-list{
        ${props => props.theme.bp.below.sm} {
            display:block;
            thead{
                display:none;
            }
            tbody{
                display:block;
            }
            tr{
                background:white;
                margin-bottom:1.5rem;
                display:flex;
                flex-direction:column;
                font-size:13px;
                td:nth-of-type(1){
                    background: ${props => props.theme.colors.secondary};
                    color:white;
                    font-size:16px;
                    font-weight:700;
                }
                td:nth-of-type(2),
                td:nth-of-type(3),
                td:nth-of-type(4){
                    display:flex;
                    &::before{
                        font-weight:700;
                        width:30%;
                    }
                }
                td:nth-of-type(2)::before{
                        content:"Adress";
                    
                }
                td:nth-of-type(3)::before{
                        content:"Postnr + Ort";
                }
                td:nth-of-type(4)::before{
                        content:"Mail för PDF";
                }
            }
        }
    }
`
